import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {MINUS__12, MINUS__16, CHECK__12, CHECK__16} from '@homeaway/svg-defs';
import classNames from 'classnames';
import './CheckRadioBase.less';

/**
 * CheckRadioBase
 *
 * This is the base component for RadioButtons and Checkboxes.
 */

class CheckRadioBase extends Component {
    static propTypes = {
        /** Text label, can also contain other content if you need it. */
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.element
        ]),
        /** Mark the component as checked */
        checked: PropTypes.bool,
        /** If you intend to use these inline (horizontal). */
        inline: PropTypes.bool,
        /** Set to true to turn it red, such as when it is required */
        error: PropTypes.bool,
        /** Size variation. Default is 24px width/height; 'sm' will change both to 16px */
        size: PropTypes.oneOf(['sm']),
        /** Called when the checked property changes */
        onChange: PropTypes.func,
        /** Ignore, part of the base component */
        type: PropTypes.oneOf(['radio', 'checkbox'])
    };

    static defaultProps = {
        onChange: () => {}
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.input) {
            this.input.indeterminate = this.props.indeterminate;
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.indeterminate !== this.props.indeterminate) {
            this.input.indeterminate = this.props.indeterminate;
        }
    }

    render() {
        let {label, checked, type, error, className, inline, size, children, onChange, onMouseUp, onTouchEnd, indeterminate, ...rest} = this.props;

        const parentClasses = classNames(className, {
            'form-group': true,
            'CRB': true,
            [`CRB--${type}`]: true,
            'CRB--inline': inline,
            [`CRB--${size}`]: size,
            'has-error': !!error,
            'CRB--disabled': !!this.props.disabled
        });

        const inputClasses = classNames('CRB__input', {
            ['CRB__input--error']: !!error
        });

        const labelClasses = classNames('CRB__label',
            {['CRB__label--error']: !!error},
            'text-muted'
        );

        return (
            <div className={parentClasses} role="checkbox" aria-checked={checked} onTouchEnd={onTouchEnd} onMouseUp={onMouseUp}>
                <label className={labelClasses}>
                    <input
                        ref={
                            /* istanbul ignore next */
                            (e) => {
                                this.input = e;
                            }
                        }
                        type={type}
                        className={inputClasses}
                        {...rest}
                        checked={checked}
                        onChange={onChange}
                    />

                    <span className="CRB__toggle">
                        {type === 'checkbox' && !indeterminate && this.props.checked &&
                            <SVGIcon inlineFlex className="CRB__svg" markup={size === 'sm' ? CHECK__12 : CHECK__16} />
                        }
                        {type === 'checkbox' && indeterminate &&
                            <SVGIcon inlineFlex className="CRB__svg" markup={size === 'sm' ? MINUS__12 : MINUS__16} />
                        }
                    </span>

                    <span className="label-text">{label}</span>
                </label>
                {children}
            </div>
        );
    }
}

export default CheckRadioBase;
